<template>
  <NotificationController
    :notificationConfig="$options.NotificationConfig"
  >
    <template
      v-slot="slotProps"
    >
      <NotificationContainer
        :class="$style.notificationContainer"
        data-test-id="AppNotificationController__notifications"
        :notifications="slotProps.notifications"
        @removeNotification="slotProps.removeNotification"
      />
    </template>
  </NotificationController>
</template>

<script>
import { NotificationContainer, Types } from '@jumpcloud/ui-components';
import { NotificationController } from '@jumpcloud/ui-notifications';

const { NotificationConfig } = Types;

export default {
  name: 'AppNotificationController',

  components: {
    NotificationController,
    NotificationContainer,
  },

  NotificationConfig,

};
</script>

<style module scoped>
.notificationContainer.notificationContainer {
  z-index: 9999;
}
</style>
